var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "xMidYMid meet",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 20.4008 20.1667",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Fill",
    d: "M8.36631 16.5C8.36631 17.5125 9.18712 18.3333 10.1996 18.3333C11.2121 18.3332 12.033 17.5125 12.033 16.5H8.36631ZM10.1996 1.83333C7.16208 1.83333 4.69965 4.29577 4.69965 7.33333V12.1279L2.40888 14.6667H17.9922L15.6996 12.127V7.33333C15.6996 4.29587 13.2371 1.83346 10.1996 1.83333ZM13.8663 16.5C13.8663 18.525 12.2246 20.1666 10.1996 20.1667C8.1746 20.1667 6.53298 18.525 6.53298 16.5H1.37763L1.26752 16.4955C0.148311 16.4118 -0.416306 15.0606 0.357117 14.2039L2.86631 11.4234V7.33333C2.86631 3.28325 6.14956 0 10.1996 0L10.5765 0.009847C14.4514 0.206128 17.533 3.40972 17.533 7.33333V11.4216L20.044 14.2039C20.8169 15.0605 20.2524 16.4115 19.1336 16.4955L19.0235 16.5H13.8663Z",
    fill: "var(--fill-0, #29363D)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.178ccabd6959798ad9d233e2d782d237.svg";
export { ForwardRef as ReactComponent };